<script>
import { BTable } from "bootstrap-vue";
import { formatDateTime } from "@/filters/formatDate";
import FileUtil from "@/utils/fileUtil";
import { taskStatus } from "@/utils/taskStatus";

export default {
  name: "TaskList",
  components: { BTable },
  props: {
    tasks: {
      required: true,
      type: Array,
    }
  },
  data() {
    return {
      interval: null,
      fields: [
        {
          label: 'Statut',
          key: 'status'
        },
        {
          label: 'Lancé le',
          key: 'createdAt'
        },
        {
          label: 'Lancé par',
          key: 'user.username'
        },
        {
          label: 'Résultat',
          key: 'result'
        },
        {
          label: 'Action',
          key: 'action'
        }
      ]
    }
  },
  methods: {
    saveFile(content) {
      const formatedCotent = btoa(unescape(encodeURIComponent(content)))

      FileUtil.downloadFile({
        fileContents: formatedCotent,
        fileName: 'rapport-import.txt'
      }, 'text/csv;charset=utf8;');
    },
    formatDateTime,
    isInProgress: (status) => status === taskStatus.IN_PROGRESS,
    formatTaskStatus: (status) => {
      switch (status) {
        case taskStatus.FAILED:
          return '❌ Echec';
        case taskStatus.COMPLETED:
          return '✅ Succès';
        case taskStatus.IN_PROGRESS:
          return 'Import en cours'
        default:
          return 'Inconnu'
      }
    },
  },
}
</script>

<template>
  <b-table ref="table" striped hover :no-local-sorting="true" :fields="fields" :items="tasks" primary-key="createdAt">
    <template v-slot:cell(updatedAt)="row">
      {{ row.value ? formatDateTime(row.value): '-' }}
    </template>
    <template v-slot:cell(createdAt)="row">
      {{ formatDateTime(row.value) }}
    </template>
    <template v-slot:cell(status)="row">
      <b-spinner v-if="isInProgress(row.item.status)" small variant="primary"></b-spinner>
      {{ formatTaskStatus(row.value) }}
    </template>
    <template v-slot:cell(result)="row">
      <p class="result" :id="`tooltip-target-${formatDateTime(row.item.createdAt)}`">{{ row.value ? row.value : 'Pas de résultat' }}</p>
      <b-tooltip :target="`tooltip-target-${formatDateTime(row.item.createdAt)}`" triggers="hover" v-if="!isInProgress(row.item.status)">
        {{ row.value }}
      </b-tooltip>
    </template>
    <template v-slot:cell(action)="row">
      <b-button @click="saveFile(row.item.result)" v-if="!isInProgress(row.item.status)" title="Télécharger le rapport d'import" :id="`tooltip-target-error-${formatDateTime(row.item.createdAt)}`">
        <Icon icon="download" size="sm" />
      </b-button>
    </template>
  </b-table>
</template>

<style scoped>
.result {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
}
</style>
